/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupClientAliasesResponsePersonasInner
 */
export interface LookupClientAliasesResponsePersonasInner {
    /**
     * 
     * @type {string}
     * @memberof LookupClientAliasesResponsePersonasInner
     */
    stageName: string;
    /**
     * 
     * @type {string}
     * @memberof LookupClientAliasesResponsePersonasInner
     */
    personaId: string;
}

/**
 * Check if a given object implements the LookupClientAliasesResponsePersonasInner interface.
 */
export function instanceOfLookupClientAliasesResponsePersonasInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "personaId" in value;

    return isInstance;
}

export function LookupClientAliasesResponsePersonasInnerFromJSON(json: any): LookupClientAliasesResponsePersonasInner {
    return LookupClientAliasesResponsePersonasInnerFromJSONTyped(json, false);
}

export function LookupClientAliasesResponsePersonasInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupClientAliasesResponsePersonasInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageName': json['stageName'],
        'personaId': json['persona_id'],
    };
}

export function LookupClientAliasesResponsePersonasInnerToJSON(value?: LookupClientAliasesResponsePersonasInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageName': value.stageName,
        'persona_id': value.personaId,
    };
}

